import { Avatar, Heading, Pill } from '@devfolioco/genesis';
import React from 'react';
import styled, { css } from 'styled-components';

import Tooltip from 'components/Tooltip';
import ProfileIcon from './ProfileIcon';

export const TopBarContainer = styled.div`
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.color.white[0]};
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 48px 80px;
  border-radius: 6px;
  transition: box-shadow 0.4s ease-out;
  ${({ stuckTop, theme }) =>
    stuckTop &&
    css`
      box-shadow: ${theme.shadow[3]};
      border-radius: 0 0 6px 6px;
    `};

  @media (max-width: 768px) {
    padding: 32px 40px;
  }

  @media (max-width: 575px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 32px;

    h1 {
      width: min-content;
    }
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const HiddenPill = styled(Pill)`
  div,
  svg {
    height: 24px;
  }
`;

class TopBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stuckTop: false,
    };

    this.topBar = React.createRef();
    this.topBarOffset = null;
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleStickyPosition);
    this.topBarOffset = this.topBar.current.getBoundingClientRect().top;
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleStickyPosition);
  }

  handleStickyPosition = () => {
    const { stuckTop } = this.state;
    const scroll = window.scrollY;

    if (scroll > this.topBarOffset) {
      if (!stuckTop) {
        this.setState({ stuckTop: true });
      }
    } else if (stuckTop) {
      this.setState({ stuckTop: false });
    }
  };

  render() {
    const { profileImageURL, displayName, otherProfiles, publicProfileVisible, isUserSelf, username } = this.props;

    const { stuckTop } = this.state;

    return (
      <TopBarContainer ref={this.topBar} stuckTop={stuckTop}>
        <Flex
          css={`
            flex-grow: 1;
          `}
        >
          <Avatar alt={username} size="large" src={publicProfileVisible ? profileImageURL : ''} />

          <div style={{ marginLeft: 24 }}>
            <Heading appearance="H1">{displayName}</Heading>
          </div>
        </Flex>

        <Flex
          css={`
            margin-top: 0;
            justify-content: center;
            flex-wrap: wrap;
            @media (max-width: 880px) {
              margin-top: 1rem;
            }
          `}
        >
          {publicProfileVisible ? (
            otherProfiles.map(profile => {
              const { value } = profile;
              const profileURL = value.startsWith('http') ? value : `https://${value}`;

              return <ProfileIcon key={profile.uuid} username={username} name={profile.name} href={`${profileURL}`} />;
            })
          ) : (
            <Tooltip
              data={() => (isUserSelf ? 'This profile is hidden by you' : 'This profile is hidden by user')}
              popperStyle={{ marginBottom: 16 }}
            >
              {() => <HiddenPill size="medium" label="Hidden" color="white-0" background="grey-7" icon="eye" />}
            </Tooltip>
          )}
        </Flex>
      </TopBarContainer>
    );
  }
}

export default TopBar;
